module.exports = __webpack_public_path__ + "img/mobile-catch-assets-04.22994824.png";